import { Link } from 'react-router-dom'
import type { UnitHolds } from '../../api/lab'
import { HOLD_SCOPE_LABEL, PACK_LOT_HOLD_LABEL, UNIT_TYPE_LABEL, holdReasonText, unitLink } from '../../model/lab/labText'
import { Code, RefLink, Status } from '../bits'

/** Everything a lab fail holds that reaches this unit (F7-B1.a), read-only. */
export function HeldUnitsList({ holds }: { holds: UnitHolds }) {
  return (
    <div className="flex flex-col">
      <ul className="divide-y divide-rule/70">
        {holds.held.map((h) => {
          const to = h.packLotId ? `/c/pack-lots/${h.packLotId}` : unitLink(h.unitType, h.unitId)
          return (
            <li key={h.unitId} className="flex flex-wrap items-start justify-between gap-2 px-4 py-2.5 text-[14px]">
              <span className="min-w-0">
                <span className="flex flex-wrap items-center gap-2">
                  {to ? <RefLink to={to}>{h.packLotCode ?? h.code}</RefLink> : <Code>{h.code}</Code>}
                  <span className="text-[12.5px] text-muted">{UNIT_TYPE_LABEL[h.unitType] ?? h.unitType}</span>
                  {h.pouchCount !== null && <span className="text-[12.5px] text-muted">· {h.pouchCount} pouches</span>}
                  {h.locationCode && <span className="text-[12.5px] text-muted">· at {h.locationCode}</span>}
                </span>
                <span className="block text-[12.5px] text-muted">
                  {h.holdReason ? holdReasonText(h.holdReason) : (HOLD_SCOPE_LABEL[h.scope] ?? h.scope)}
                  {h.labReportId && (
                    <>
                      {' · '}
                      <Link to={`/c/lab-reports/${h.labReportId}`} className="underline decoration-rule underline-offset-2">
                        Lab report
                      </Link>
                    </>
                  )}
                </span>
              </span>
              <span className="flex shrink-0 flex-wrap gap-1">
                {h.packLotStatus ? (
                  <>
                    <Status status={h.packLotStatus} />
                    {h.packLotHold && h.packLotHold !== 'NONE' && <Status status={h.packLotHold} label={PACK_LOT_HOLD_LABEL[h.packLotHold]} />}
                  </>
                ) : (
                  h.hold !== 'NONE' && <Status status={h.hold} label="On hold" />
                )}
              </span>
            </li>
          )
        })}
      </ul>
      {holds.exceptionId && (
        <Link to={`/c/exceptions?open=${holds.exceptionId}`} className="border-t border-rule px-4 py-2 text-[13px] underline decoration-rule underline-offset-2">
          Open the lab-fail problem
        </Link>
      )}
    </div>
  )
}
